"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var inversify_react_1 = require("inversify-react");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var BackgroundStyleManager_1 = require("./BackgroundStyleManager");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var BackgroundColorSettings = function (_a) {
    var handleBackgroundChange = _a.handleBackgroundChange;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var backgroundStyleManager = (0, inversify_react_1.useInjection)(BackgroundStyleManager_1.BackgroundStyleManager);
    var blockStyleStore = blockStore.blockStyleStore;
    var presetBackgroundColors = brandStore.colorsWithThemeIndex;
    var background;
    if ("background" in blockStyleStore.model) {
        background = blockStyleStore.model.background;
    }
    else {
        background = { abs: DefaultColors_1.DEFAULT_WHITE.value, themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex };
    }
    var onBackgroundColorChange = function (color) {
        backgroundStyleManager.setBackgroundProperties(__assign({ themeIndex: color.themeIndex, abs: background.opacity == null ? color.value : (0, ColorUtils_1.replaceOpacity)(color.value, background.opacity) }, (0, CommonUtils_1.includeIf)(background.opacity == null, {
            opacity: 1,
        })));
        if (handleBackgroundChange) {
            handleBackgroundChange(color);
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", paddingRight: "l", paddingLeft: "l" },
        react_1.default.createElement(ColorPalette_1.default, { theme: "light", onColorChange: onBackgroundColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(background), presetBackgroundColors), presetColors: presetBackgroundColors, includeColorPanelPicker: true, type: "block" })));
};
exports.default = (0, WithColorFilterSubscription_1.default)(BackgroundColorSettings);
